module.exports = __webpack_public_path__ + "static/media/5d_2.d5cbcd55.png";